import { 
    API_FAILURE_TRANSITION_STATUS,
    API_INITIAL_TRANSITION_STATUS,
    API_PENDING_TRANSITION_STATUS,
    API_SUCCESS_TRANSITION_STATUS,
    DURATION_SET_VALID, 
    DURATION_SET_VALUE, 
    FAULU_LOAN_SIDEBAR_OPEN_VALUE, 
    FORM_INVALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION, 
    FORM_VALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION, 
    INTEREST_SET_VALID,
    INTEREST_SET_VALUE, 
    LOAN_AMOUNT_SET_VALID, 
    LOAN_AMOUNT_SET_VALUE,
    LOAN_RESULT_SET_VALUE,
    REINITIALIZE_STATE_FAULU_LOAN_CALCULATOR_FORM, 
    REPAYMENT_DURATION_SET_VALID, 
    REPAYMENT_DURATION_SET_VALUE, 
    TOKEN_IS_EXPIRED
} from "../../actions/fauluLoanCalculator/fauluLoanCalculatorForm";
import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from "../status";


const initialState = {
    sidebarOpen: false,
    formStatus: FORM_STATUS.INVALID,
    apiCallStatus: null,
    duration : [
        {
            value: 'month',
            description: 'Months',
        },
        {
            value: 'year',
            description: 'Year',
        }
    ],
    form: {
        amount: { value: null, error: null, status: null },
        interest: { value: null, error: null, status: null },
        repaymentDuration: { value: null, error: null, status: null },
        duration: { value: 'month', error: null, status: 'valid' },
    },
    result: null,
    ugCmbObject: {
        __typename: 'Contentstack_call_me_back_ke',
        product: 'Faulu Loan Calculator',
        privacy_policy_url: '/privacy-policy/',
        extra_fields: ['Email Address'],
    },
    isTokenExpired: false
};

export default (state = initialState, action) => {
    const mapError = error =>  error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID;
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch(action.type) {
        case FORM_VALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_FAULU_LOAN_CALCULATOR_FORM_TRANSITION:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case API_INITIAL_TRANSITION_STATUS:
            return { ...state, apiCallStatus: null };

        case API_PENDING_TRANSITION_STATUS:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRANSITION_STATUS:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRANSITION_STATUS:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };
        
        case LOAN_RESULT_SET_VALUE:
            return { ...state, result: action.value }
        
        case FAULU_LOAN_SIDEBAR_OPEN_VALUE:
            return { ...state,sidebarOpen: action.value};
        
        case TOKEN_IS_EXPIRED:
            return { ...state, isTokenExpired: action.value };
                        
        case LOAN_AMOUNT_SET_VALUE:
            return updateFormField('amount', field => ({
                ...field,
                value: action.value,
            }));
        case LOAN_AMOUNT_SET_VALID:
            return updateFormField('amount', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        
        case REPAYMENT_DURATION_SET_VALUE:
            return updateFormField('repaymentDuration', field => ({
                ...field,
                value: action.value,
            }));
        case REPAYMENT_DURATION_SET_VALID:
            return updateFormField('repaymentDuration', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case DURATION_SET_VALUE:
            return updateFormField('duration', field => ({
                ...field,
                value: action.value,
            }));
        case DURATION_SET_VALID:
            return updateFormField('duration', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case INTEREST_SET_VALUE:
            return updateFormField('interest', field => ({
                ...field,
                value: action.value,
            }));
        case INTEREST_SET_VALID:
            return updateFormField('interest', field => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case REINITIALIZE_STATE_FAULU_LOAN_CALCULATOR_FORM:
            return {
                ...state,
                ...initialState
            }

        default:
            return state;
    }
}